import { connect } from 'react-redux';
import { setCameraMode } from '../../redux/actions/rootAction';
import React from 'react';
import { Actions, ActionsButton, ActionsGroup } from 'framework7-react';
import II18 from '../translate/II18';
import { gae } from '../helpers/Analytics';
import PropTypes from 'prop-types';
import { prepareScanUtils } from '../helpers/utils';
import { handleSourcePdfLoaded } from '../../lib/pendingSourcePdfs';

require('../../lib/scanutils');

const mapStateToProps = (state, ownProps) => ({
  recipientRequestId: state.recipientRequestId,
  cameraMode: state.cameraMode,
  updateCameraMode: ownProps.cameraMode,
  scannedDocuments: state.scannedDocuments,
  templateMode: state.templateMode
});

const mapDispatchToProps = dispatch => ({
  setCameraMode: as => dispatch(setCameraMode(as))
});

class Uploader extends React.Component {
  componentDidMount() {
    prepareScanUtils();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.opened &&
      (this.props.cameraMode !== null || this.props.updateCameraMode === true)
    ) {
      this.loadImage(this.props.updateCameraMode);
      this.props.onActionsClosed();
    }
  }

  loadImage(updateCameraMode) {
    const {
      recipientRequestId,
      documentId,
      setCameraMode,
      onImageLoaded,
      cameraMode,
      allowMultiply,
      setDocumentPdfUploaded,
      scannedDocuments,
      templateMode
    } = this.props;

    try {
      if (updateCameraMode !== undefined) {
        updateCameraMode
          ? window.utils.setLoadCameraMode()
          : window.utils.setLoadFileMode();
      }

      const useCameraMode =
        updateCameraMode !== undefined ? updateCameraMode : cameraMode;

      if (useCameraMode) {
        window.utils.setAllowMultyFiles(false);
        window.utils.setOnMultyUploadDone(null);

        window.utils.setOnImageLoadComplete(() => {
          gae('UPLOADER', 'ON_IMAGE_LOAD_COMPLETE');
          window.utils.processLoadedImageToPreview();
        });

        window.utils.setOnImagePreviewComplete(() => {
          gae('UPLOADER', 'ON_IMAGE_PREVIEW_COMPLETE');
          if (onImageLoaded) {
            if (updateCameraMode !== undefined) {
              setCameraMode(updateCameraMode);
            }
            onImageLoaded(documentId);
          }
        });
        window.utils.getLoadButtonClickEvent()();
      } else {
        const hasScannedPages = scannedDocuments.get(documentId);
        Uploader.loadFromFile(
          allowMultiply,
          (urls, sourcePdf) => {
            gae(
              'UPLOADER',
              'ON_IMAGE_FROM_FILE_COMPLETE',
              sourcePdf ? 'PDF' : 'IMAGE'
            );
            if (updateCameraMode !== undefined) {
              setCameraMode(updateCameraMode);
            }
            if (urls.length === 1 && !sourcePdf) {
              window.utils.processLoadedImageToPreview();
            }
            onImageLoaded(
              documentId,
              urls.length > 1 || sourcePdf ? urls : false
            );
          },
          () => this.$f7.dialog.progress(II18.get('title_load'), 0),
          !(hasScannedPages && hasScannedPages.size) &&
            ((file, filesCount) => {
              handleSourcePdfLoaded({
                templateMode,
                recipientRequestId,
                documentId,
                file,
                filesCount,
                setDocumentPdfUploaded,
                gaeCategory: 'UPLOADER'
              });
            })
        );
      }
    } catch (error) {
      console.error(error);
    }
  }

  static loadFromFile(allowMultiply, onUploadDone, openDialog, onPDFLoaded) {
    prepareScanUtils();

    try {
      let images = [];
      let progress = 0;
      let progressStep = 0;
      let pageIndex = 0;
      let filesCount = 0;
      let pdfMode = 0;
      let progressPdf = 0;
      let progressStepPdf = 0;
      let pageIndexPdf = 0;
      let pagesPdf = 0;
      let pdfPagesCount = 0;
      let dialog = null;

      window.utils.setLoadFileMode();
      window.utils.setAllowMultyFiles(allowMultiply);
      window.utils.setShowSpinnerOnProcessingImage(true);
      window.utils.setOnImagePreviewComplete(null);

      window.utils.setOnPDFLoaded(onPDFLoaded);

      window.utils.setOnMultyUploadDone(() => {
        window.utils.hideSpinner();
        if (dialog) {
          dialog.close(false);
        }
        onUploadDone(images, pdfPagesCount > 0);
      });

      window.utils.setOnImageLoadComplete(() => {
        images.push(window.utils.processLoadedImageToResize());

        if (dialog) {
          if (pdfMode && pagesPdf - pageIndexPdf > 1) {
            progressPdf += progressStepPdf;
            pageIndexPdf++;
            dialog.setProgress(progressPdf);
            dialog.setText(
              II18.get('common_page_x_from_y_2', [pageIndexPdf, pagesPdf])
            );
          } else {
            pdfMode = 0;
            dialog.setTitle(II18.get('title_load'));
            progress += progressStep;
            pageIndex++;
            dialog.setProgress(progress);
            dialog.setText(
              II18.get('common_page_x_from_y_2', [pageIndex, filesCount])
            );
          }
        }
      });

      window.utils.setOnPDFLoadStart(count => {
        pdfPagesCount++;
        if (allowMultiply) {
          if (!dialog) {
            dialog = openDialog();
          }
          dialog.setTitle(
            'PDF ' +
              (filesCount > 1 ? pdfPagesCount : '') +
              II18.get('title_will_prepared')
          );
        }
        progressPdf = 0;
        pageIndexPdf = 0;
        progressStepPdf = 100 / count;
        pagesPdf = count;
        pdfMode = 1;
      });

      window.utils.setOnImageLoadStart(count => {
        filesCount = count;
        if (filesCount > 1) {
          window.utils.setShowSpinnerOnProcessingImage(false);
          dialog = openDialog();
          progressStep = 100 / count;
        }
      });

      window.utils.getLoadButtonClickEvent()();
    } catch (error) {
      console.error(error);
    }
  }

  render = () => {
    /* update */
    return (
      <Actions
        id="uploader_actions"
        closeByOutsideClick={false}
        opened={
          this.props.opened &&
          this.props.cameraMode === null &&
          this.props.updateCameraMode !== true
        }
        onActionsClosed={() => {
          gae('UPLOADER', 'UPLOAD_ACTIONS_MENU.CLOSE');
          this.props.onActionsClosed();
        }}
      >
        <ActionsGroup>
          <ActionsButton
            id={'scanCamera'}
            onClick={() => {
              gae('UPLOADER', 'DO_ADD_PAGE_FROM_CAMERA');
              this.loadImage(true);
            }}
          >
            <II18>upload_camera</II18>
          </ActionsButton>

          <ActionsButton
            id={'scanDisk'}
            onClick={() => {
              gae('UPLOADER', 'DO_ADD_PAGE_FROM_DISK');
              this.loadImage(false);
            }}
          >
            <II18>upload_disk</II18>
          </ActionsButton>

          {/*!this.props.scanEnded && this.props.allowReject && (
            <ActionsButton
              id={'reject'}
              color="red"
              onClick={() => {
                this.props.onRejectDocument();
              }}
            >
              <II18>title_reject</II18>
            </ActionsButton>
          )*/}
        </ActionsGroup>

        <ActionsGroup>
          <ActionsButton id={'scanCancel'}>
            <II18>title_cancel</II18>
          </ActionsButton>
        </ActionsGroup>
      </Actions>
    );
  };
}

Uploader.propTypes = {
  allowReject: PropTypes.bool,
  recipientRequestId: PropTypes.string,
  documentId: PropTypes.string,
  onRejectDocument: PropTypes.func,
  setCameraMode: PropTypes.func,
  onImageLoaded: PropTypes.func,
  cameraMode: PropTypes.bool,
  allowMultiply: PropTypes.bool,
  scanEnded: PropTypes.bool,
  opened: PropTypes.bool,
  setDocumentPdfUploaded: PropTypes.func,
  updateCameraMode: PropTypes.bool,
  onActionsClosed: PropTypes.func,
  scannedDocuments: PropTypes.object,
  templateMode: PropTypes.bool
};

export default connect(mapStateToProps, mapDispatchToProps)(Uploader);
